import '../../css/base.css';
import dinosaurFootprint_large from '../../img/dinosaurFootprint_large.jpg'
import dinosaurFootprint_medium from '../../img/dinosaurFootprint_medium.jpg'
import dinosaurFootprint_small from '../../img/dinosaurFootprint_small.jpg'


const DayTrips = () => {

  return (
    <div className="row">
        <div className="col-12">
          <p className="walk-text">These are three of our personal favourite days out.  There are so many places to visit in this part of 
                                  the highlands if you feel the need to explore further than Arnisdale and Glenelg. 
          </p>
        </div>               
        <div className="col-12 col-md-6">
          <h2 className="walks-section-heading">Eilean Donan Castle and Plockton</h2>
          <p className="walk-text">Visit the world famous 13th century Eilean Donan Castle with its stunning location on a small island.  Continue on 
                                  to visit the beautiful village of Plockton for a boat trip and perhaps a visit to one of the seafood restaurants.   A longer
                                  day takes you further up the coast to the Applecross peninsula and the highest road in Britain over the Bealach na Ba pass.  
                                  This is a must for cyclists.
          </p>                             
        </div>               
        <div className="col-12 col-md-6">
          <h2 className="walks-section-heading">Skye Turntable Ferry and Elgol</h2>
          <p className="walk-text">Taking the turntable ferry to Skye is an experience in it's own right.  The trip crosses the narrow straights 
                                  from Glenelg to Kylerhea.  Watch out for Sea Eagles.  There is an RSPB hide on the Skye side with Otters often 
                                  spotted.  Head up a single track road to Broadford before turning south to Elgol.  Just after the village of Kilmarie
                                  you can take one of my favourite walks to Camasunary.  It is about a 2 hour walk and gives you an amazing view of 
                                  Camasunary Bay with the Cuillin as a backdrop.  Alternatively continue onto Elgol where the view is almost as good.
                                  There are options of a boat trip to the remote Loch Coruisk with Misty Isle Boat Trips.
          </p>                                            
        </div>
        <div className="col-12 col-md-6">
          <h2 className="walks-section-heading">Skye Trotternish Peninsula</h2>
          <p className="walk-text">North of Portree on Skye is the Trotternish peninsula.  There are amazing rock formations and dinosaur footprints 
                                  to be found.  The Old Man of Storr is the first to explore.  Next up dinosaur footprints at An Corran Beach near Staffin.
                                  Not easy to spot but a lot easier if it is near low tide (see photo). Then finally more amazing rock formations at the Quiraing.  A big 
                                  day our but so much to explore with the scenery spectacular.  Stop at the Sligachan Hotel for a bite to eat at Seumas' Bar on the drive home.
          </p>  
        </div>    
        <div className="col-12 col-md-6 imagesBackgroundColour">
        <picture>
          <source srcSet={`${dinosaurFootprint_small} 1x,${dinosaurFootprint_medium} 2x`} media="(max-width: 600px)" />
          <img srcSet={`${dinosaurFootprint_medium} 1x,${dinosaurFootprint_large} 2x`}
            src={dinosaurFootprint_large} alt="Dinosaur Footprint" className="image"
          />
        </picture>
      </div>
                                      
    </div>
  );
}

export default DayTrips;